<template>
  <el-dialog :visible.sync="dialogVisible" size="small" width="1000px" @close="$emit('close',dialogVisible)">
    <el-row slot="title">
      <span>结算卡快速修改</span>
      <span :class="statusColor" class="status" v-if="stateId !== undefined && stateId !== -1"><i class="el-icon-warning-outline"></i>{{ stateStr }}</span>
      <!--              审核失败时，显示原因-->
      <span class="reviewTime" v-if="stateId === 1">退回原因：{{ remark }}</span>
    </el-row>
    <div v-loading="settleLoading">
      <el-form
        label-width="120px"
        label-position="left"
        ref="quickChangeBankInfoForm"
        :model="form"
        :rules="rule_data">
        <el-form-item :label="accountTypeLabel" prop="bankcardFront" :required="form.accountType === 1">
          <ocr-recognition
            type="9"
            :value="form.bankcardFront"
            v-if="form.accountType === 1"
            :to-check="needOcr"
            valueName="bankForm.bankcardFront"
            @submit="getOCRResult"></ocr-recognition>
          <upload-img-ele
            :value="form.bankcardFront"
            v-else
            valueName="bankForm.bankcardFront"
            @upload="uploadSuccess"
            :required="false"></upload-img-ele>
        </el-form-item>
        <el-form-item label="开户名" prop="holder">
          <el-input class="form-input" v-model="form.holder" disabled @focus="needHideInfoInputFocus('holder')"></el-input>
        </el-form-item>
        <el-form-item label="开户人证件" v-show="form.accountType !== 2">
          <el-input style="width: 500px;" v-model="form.bankIdCard" placeholder="法人证件号码，如有字母需大写" disabled @focus="needHideInfoInputFocus('bankIdCard')">
            <el-select style="width:130px;" slot="prepend" placeholder="请选择证件类型" v-model="form.bankIdCardType" disabled>
              <el-option label="身份证" :value="1"></el-option>
              <el-option label="港澳台通行证" :value="2"></el-option>
              <el-option label="台湾身份证" :value="3"></el-option>
              <el-option label="香港身份证" :value="4"></el-option>
              <el-option label="澳门身份证" :value="5"></el-option>
              <el-option label="护照" :value="6"></el-option>
              <el-option label="居住证" :value="7"></el-option>
              <el-option label="其他法定证件" :value="9"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="开户号" prop="bankCardId">
          <el-input class="form-input" v-model="form.bankCardId" :placeholder="form.accountType === 2 ? '请填写开户许可证号' : '请填写结算人银行卡号'" @blur="handleBankCardIdBlur" @focus="needHideInfoInputFocus('bankCardId')"></el-input>
        </el-form-item>
        <bank-branch
          ref="bankBranchForm"
          labelWidth="120px"
          :value="bankBranch"
          v-model="bankBranch"
          :bankCardId="lumhBankCardId"
          @getValue="getBankBranch"></bank-branch>
        <el-form-item label="预留号码" prop="bankBindMobile">
          <el-input v-model="form.bankBindMobile" style="width: 30%" @focus="needHideInfoInputFocus('bankBindMobile')">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" style="width:100%" v-show="editable">
      <el-button icon="el-icon-edit" type="primary" @click="saveSettle" :loading="buttonLoading" :disabled="stateId === 0">提交审核</el-button>
      <el-button @click="cancelEdit()" >取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import qs from 'qs'
import bankBranch from '@/components/bankBranch'
import { hideBankCardNum, hideRealName, hidePhoneNum } from '@/utils/hideSensitiveInfo.js'
// import luhmCheck from '@/utils/luhmCheck.js'
import ocrRecognition from '@/components/OCRRecognition'
import uploadImgEle from '@/components/upload/uploadImgEle'
import { getMerchantInfo, checkSettleStatus, quicklyModifyAccount } from '@/api/merchant'
import { findBranch } from '@/api/global'
export default {
  name: 'SettleForm',
  components: {
    bankBranch,
    ocrRecognition,
    uploadImgEle
  },
  props: {
    merchantId: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  },
  computed: {
    bankBranch () {
      return {
        bankNameCode: this.form.FBankTypeCode, // 银行类型编码
        bankCityCode: this.form.FBankCityCode, // 银行网点市编码
        bankAreaCode: this.form.FBankAreaCode, // 银行网点省编码
        bankBranchCode: this.form.unionpay// 分行id
      }
    }
  },
  data () {
    return {
      dialogVisible: false, // 是否显示
      stateStr: '等待审核', // 审核状态文本
      stateId: '', // 审核状态
      settleLoading: false, // 加载结算信息
      buttonLoading: false, // 提交按钮加载
      // lastedReviewTime:'',//最新审核时间
      remark: '', // 审核退回原因
      editable: false, // 是否显示提交按钮
      form: {
        merchantId: '',
        branch: '', // 网点名称
        unionpay: '', // 支行网点编号
        holder: '', // 开户名
        bankIdCardType: '', // 证件类型
        bankIdCard: '', // 开户人证件
        bankCardId: '', // 开户号
        accountType: '', // 账户类型，1对私账户，2对公账户
        bankBindMobile: '', // 预留号码
        bankcardFront: ''// 银行卡正面/开户许可证
      },
      rule_data: {
        holder: [
          { required: true, message: '请输入正确的开户名', pattern: /(?!^\w+$)^.{1,80}$/, trigger: 'blur' },
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }
        ],
        bankCardId: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error(`${this.form.accountType === 2 ? '请输入正确的开户许可证账号' : '请输入正确的个人银行卡号'}`))
            } else {
              callback()
            }
            //  else {
            //   if ((this.form.accountType === 2) && (/^\S{5,30}$/.test(value) || value.includes('*'))) {
            //     callback()
            //   // } else if (this.form.accountType !== 2 && ((/^\d{16,19}$/.test(value) && luhmCheck(value)) || value.includes('*'))) {
            //   } else if (this.form.accountType !== 2 && (/^\d{16,19}$/.test(value) || value.includes('*'))) {
            //     callback()
            //   } else {
            //     callback(new Error(`${this.form.accountType === 2 ? '请输入正确的开户许可证账号' : '请输入正确的个人银行卡号'}`))
            //   }
            // }
          },
          required: true,
          trigger: 'blur'
        }],
        bankBindMobile: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                // callback(new Error('请输入预留号码'))
                callback()
              } else {
                if (!(/^(\d{3,4}-?)?\d{7,9}$/.test(value) || /^(((13[0-9]{1})|(15[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(16[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(value)) && !value.includes('*')) {
                  callback(new Error('请输入正确手机号或座机号'))
                } else {
                  callback()
                }
              }
            },
            required: false,
            trigger: 'blur'
          }
        ],
        bankcardFront: [{
          validator: (rule, value, callback) => {
            if (this.form.accountType === 1 && (value === '' || value === undefined)) {
              callback(new Error('请上传银行卡正面/开户许可证'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      },
      lumhBankCardId: '', // 校验通过的银行卡号
      bankTypeError: false, // 银行名称是否正确
      accountTypeLabel: '银行卡照片',
      needOcr: true, // 是否需要OCR查询
      statusColor: ''
    }
  },
  mounted () {
    this.getSettle()
    this.dialogVisible = this.visible
  },
  methods: {
    // 获取结算卡相关信息
    getSettle () {
      this.settleLoading = true
      var data = {
        merchantId: this.merchantId
      }
      var that = this
      data = qs.stringify(data)
      getMerchantInfo(data).then(data => {
        this.settleLoading = false
        this.needOcr = false
        if (parseInt(data.result_cde) !== 0) {
          this.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        } else {
          var basic = data.basic
          var pics = data.pics || ''
          that.pics = pics

          basic.realfBankHolder = basic.fBankHolder
          basic.realfBankAccount = basic.fBankAccount
          basic.realfBankcardPhone = basic.fBankcardPhone
          basic.fBankHolder = hideRealName(basic.fBankHolder)
          basic.fBankAccount = hideBankCardNum(basic.fBankAccount)
          basic.fBankcardPhone = hidePhoneNum(basic.fBankcardPhone)

          that.form.merchantId = that.merchantId

          if (basic.fBankNameCode && basic.fBankNameCode.indexOf('C') >= 0) {
            that.form.FBankTypeCode = basic.fBankNameCode
            that.form.FBankCityCode = basic.fBankCityCode
            that.form.FBankAreaCode = basic.fBankProvinceCode
            that.form.unionpay = basic.fUnionpayCode
          } else {
            this.getInfoByUnion(basic.fUnionpayCode)
          }
          that.form.accountType = basic.accountType === undefined ? '' : basic.accountType
          that.form.holder = basic.fBankHolder
          // 如果是法人结算，开户人证件类型等于法人证件类型，否则为身份证
          if (basic.legalFlag === 1) {
            that.form.bankIdCardType = basic.fCredentialType
          } else {
            that.form.bankIdCardType = 1
          }
          that.form.bankIdCard = basic.bankIdCard
          that.form.bankCardId = basic.fBankAccount
          that.form.bankBindMobile = basic.fBankcardPhone
          that.form.bankcardFront = pics.bankcardFrontUrl
          that.accountTypeLabel = that.form.accountType === 1 ? '银行卡照片' : '开户许可证照片'
          that.$nextTick(function () {
            that.needOcr = true
          })
          let request = {
            merchantId: this.merchantId
          }
          request = qs.stringify(request)
          checkSettleStatus(request).then(res => {
            console.log(res)
            if (parseInt(res.result_cde) === 0) {
              that.editable = true
              that.settleLoading = false
              that.stateId = res.data.code
              switch (that.stateId) {
                case 1: {
                  that.stateStr = '审核不通过'
                  that.statusColor = 'red'
                  that.remark = res.data.desc
                  break
                }
                case 0:
                case 2:
                {
                  that.stateStr = '审核中'
                  that.statusColor = 'blue'
                  break
                }
                case 3: {
                  that.stateStr = '审核通过'
                  that.statusColor = 'green'
                  break
                }
                case -1: {
                  that.stateStr = '无审核修改记录'
                  that.statusColor = 'blue'
                  break
                }
                default: {
                  that.stateStr = '状态异常'
                  that.statusColor = 'blue'
                }
              }
            } else {
              that.$message({
                message: res.result_msg,
                type: 'error'
              })
            }
          })
        }
      }).catch(() => {
        this.settleLoading = false
      })
    },
    cancelEdit () {
      if (this.stateId !== 0) {
        this.$confirm('请确认是否放弃当前修改内容?', '提示', {}).then(() => {
          this.buttonLoading = false
          this.$emit('submit', false)
        })
      } else {
        this.buttonLoading = false
        this.$emit('submit', false)
      }
    },
    /**
             * 需要隐藏信息的输入框获取焦点
             */
    needHideInfoInputFocus (type) {
      if (this.form[type]) {
        this.form[type] = ''
      }
    },
    // 开户号输入框失去焦点事件
    handleBankCardIdBlur () {
      if (this.form.bankCardId) {
        this.lumhBankCardId = this.form.bankCardId
      }
    },
    /**
             * @description 银行分行选中回调
             * @param {Object} val 组件传的参数，分行选中数据
             */
    getBankBranch (val) {
      const that = this
      that.form.FBankTypeCode = val.bankNameCode// 银行类型编码
      that.form.FBankCityCode = val.bankCityCode// 银行类型编码
      that.form.FBankAreaCode = val.bankAreaCode// 银行类型编码
      that.form.unionpay = val.bankBranchCode// 分行id
    },
    /**
             * @description 图片上传成功的回调
             * @param {Object} data 图片对象
             */
    uploadSuccess (data) {
      const name = data.valueName
      this.form[name] = data.path
    },
    saveSettle () {
      this.$refs.quickChangeBankInfoForm.validate((valid) => {
        if (valid) {
          const that = this
          that.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.buttonLoading = true
            let params = {
              merchantId: that.form.merchantId,
              bankCardAccount: that.form.bankCardId,
              unionpayCode: that.form.unionpay,
              bankCardPhone: that.form.bankBindMobile,
              bankCardPic: that.form.bankcardFront
            }
            params = qs.stringify(this.dismissBlank(params))
            quicklyModifyAccount(params).then(data => {
              if (data.result_cde === '0') {
                that.$message({
                  message: data.result_msg,
                  type: 'success'
                })
                that.buttonLoading = false
                that.$emit('submit', true)
              } else {
                that.$message({
                  showClose: true,
                  message: data.result_msg,
                  type: 'error'
                })
                that.buttonLoading = false
              }
            })
          })
        } else {
          this.$message({
            showClose: true,
            message: '提交信息有误，请检查',
            type: 'error'
          })
          return false
        }
      })
    },
    /**
             * @description 删除对象中字符串的空格
             * @param  {number} params 目标对象
             */
    dismissBlank (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
          const element = params[key]
          if (typeof element === 'string') {
            params[key] = element.replace(/ /g, '')
          }
        }
      }
      return params
    },
    // orc识别数据回填
    getOCRResult (data) {
      if (!data.error) {
        // 营业执照
        this.form.bankCardId = data.bankcardNo
        this.handleBankCardIdBlur()
        this.form.FBankArea = ''// 银行网点省
        this.form.FBankCity = ''// 银行网点市
        this.form.branch = ''// 分行网点
        this.form.FBankCityCode = ''
        this.form.FBankAreaCode = ''
        this.form.unionpay = ''// 分行id
      }
      this.form.bankcardFront = data.path
    },
    // 根据联行号查出银行信息
    getInfoByUnion (code) {
      const that = this
      const data = qs.stringify({
        unionpayCode: code
      })
      findBranch(data).then(response => {
        if (parseInt(response.result_cde) === 0) {
          const data = response.data
          this.form.FBankTypeCode = data.finInstitutionCode
          this.form.FBankAreaCode = data.cftAreaCode
          this.form.FBankCityCode = data.cftCityCode
          this.form.unionpay = data.unionpayCode
        } else {
          that.$message({
            message: response.result_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
    .form-input{
        width: 300px;
    }
    .status{
        margin-left: 20px;
        height: 26px;
        line-height: 26px;
        border-radius: 50px;
        padding: 0 20px;
        color: #fff;
        font-size: 13px;
        display: inline-block;
    }
    .status i{
        margin-right: 5px;
    }
    .status.red{
        background: #ff7070;
    }
    .status.green{
        background: #77d580;
    }
    .status.blue{
        background: #7bc0ff;
    }
    .reviewTime{
        line-height: 26px;
        height: 26px;
        display: inline-block;
        font-size: 12px;
    }
</style>
